// extracted by mini-css-extract-plugin
module.exports = {"notch":"fake-notch_notch__R3ZLE","notchIcon":"fake-notch_notchIcon__vk_uf"};